<template>
  <div v-if="item">
    <h5>Учитель: {{ item.full_name }}</h5>
    <h5>Группа: {{ item.group.title }}</h5>
    <hr />
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "",
    item: null,
    fields: [
      {
        col: 'col-12 col-md-12',
        label: "Предметы учителя",
        key: "disciplines",
        type: "selects",
        selectKey: "title",
        modal: "business_discipline",
        prefix: "discipline_d_fd",
      },
      {
        key: "label",
        label: "Статус учителя",
        type: "field",
        textType: "text",
        col: 'col-12 col-md-6',
      },

    ],
  }),
  props: ["id"],
  async created() {
    this.cardLink = `business/groups/${this.group_id}/customers`;
    this.item = await this.cardContent(this.cardLink, this.customer_id);
    this.item['id'] = this.customer_id;
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardLink, this.item, this.fields);
    },
  },
  computed: {
    customer_id: {
      get() {
        return (this.id.split('-')[1]) ? this.id.split('-')[1] : null
      }
    },
    group_id: {
      get() {
        return this.id.split('-')[0] ? this.id.split('-')[0] : null
      }
    },
  }
};
</script>
<style>
</style>
